import { RECEIVE_DATA_OBJECTS, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { directoryAssetsManager } from '@inpart-io/padme-iap';
import { type IDirectoryAsset, type IExtDBAssetEntry } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { isDataObject } from '@/services/data-object-helper';

import { EXT_DB_ASSET_ENTRY_MODULE } from '../ext-db-asset-entry-module';

export const BEST_MATCH = 'bestMatch';
export const BEST_MATCHES = 'bestMatches';

export const actions: ActionTree<IDirectoryAsset, unknown> = {
    [STORE_DATA_OBJECTS](context, { dataObjectList }: { dataObjectList: IDirectoryAsset[] }) {
        const directoryAssets: IDirectoryAsset[] = [];
        const extDBAssetEntries: IExtDBAssetEntry[] = [];
        dataObjectList.forEach((directoryAsset) => {
            const _directoryAsset = Object.assign({}, directoryAsset);
            // Extract task object if necessary
            if (directoryAsset?.['@extDBAssetEntries']?.length) {
                _directoryAsset['@extDBAssetEntries'] = directoryAsset['@extDBAssetEntries'].map((extDBAssetEntry) => {
                    if (isDataObject<IExtDBAssetEntry>(extDBAssetEntry)) {
                        extDBAssetEntries.push(Object.assign({}, extDBAssetEntry));
                        return extDBAssetEntry.dobjId;
                    } else {
                        return extDBAssetEntry;
                    }
                });
            }

            directoryAssets.push(_directoryAsset);
        });
        if (directoryAssets.length > 0) {
            context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: directoryAssets });
        }
        if (extDBAssetEntries.length > 0) {
            void context.dispatch(`${EXT_DB_ASSET_ENTRY_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: extDBAssetEntries }, { root: true });
        }
    },

    async [BEST_MATCH](
        context,
        { searchTerm, directoryCompany, rejected = [], properties }: { searchTerm: string; directoryCompany: number; rejected: number[]; properties?: string }
    ): Promise<IDirectoryAsset> {
        const result = await directoryAssetsManager.getMatch(searchTerm, directoryCompany, rejected, { properties });
        if (result !== null) {
            void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [result] });
        }
        return result;
    },

    async [BEST_MATCHES](
        context,
        { searchTerm, directoryCompany, rejected = [], properties }: { searchTerm: string; directoryCompany: number; rejected: number[]; properties?: string }
    ): Promise<IDirectoryAsset[]> {
        const results = await directoryAssetsManager.getMatches(searchTerm, directoryCompany, rejected, { properties });
        if (results !== null) {
            void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: results });
        }
        return results ?? [];
    }
};
